"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var emptyFolder_1 = require("./emptyFolder");
var owa_mail_list_store_1 = require("owa-mail-list-store");
var Store_1 = require("owa-mail-store/lib/store/Store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.action('emptyTableView')(legacy_1.select({
    folderToBeEmptied: function (tableViewToBeEmptied) {
        return Store_1.default.folders.folderTable.get(tableViewToBeEmptied.tableQuery.folderId);
    },
})(function emptyTableView(tableViewToBeEmptied, isExplicitSoftDelete, actionSource, rowKeysToExclude, state) {
    var folderToBeEmptied = state.folderToBeEmptied;
    // User server folder id for empty table view if it's not deleteditems or junkemail.
    // For deleteditems or junkemail, they don't support delete all with a viewFilter specified.
    if (folderToBeEmptied.distinguishedFolderId == 'deleteditems' ||
        folderToBeEmptied.distinguishedFolderId == 'junkemail') {
        emptyFolder_1.default(folderToBeEmptied, -1 /* None */, 'All', isExplicitSoftDelete, actionSource, rowKeysToExclude, tableViewToBeEmptied.selectAllModeTimeStamp, tableViewToBeEmptied.id);
    }
    else {
        // Copy properties from folderToBeEmptied to folder
        var folder = tslib_1.__assign({}, folderToBeEmptied);
        folder.FolderId = {
            Id: tableViewToBeEmptied.serverFolderId,
        };
        folder.TotalCount = tableViewToBeEmptied.totalRowsInView;
        emptyFolder_1.default(folder, owa_mail_list_store_1.getFocusedFilterForTable(tableViewToBeEmptied), owa_mail_list_store_1.getViewFilterForTable(tableViewToBeEmptied), isExplicitSoftDelete, actionSource, rowKeysToExclude, tableViewToBeEmptied.selectAllModeTimeStamp, tableViewToBeEmptied.id);
    }
}));
//# sourceMappingURL=emptyTableView.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/emptyTableView.js
// module id = 5653
// module chunks = 62